module.exports = __webpack_public_path__ + "static/media/lantern-icon.aee40467.png";